document.addEventListener('DOMContentLoaded', () => {
	// Get the search input field, questions, sections, and no-results message
	const input = document.getElementById('faq-input');
	const questions = document.querySelectorAll('.question');
	const faqSections = document.querySelectorAll('.faq-section');
	const noResults = document.querySelector('.faq-no-results');
	if (!input) return;

	// Run every time the user types in the input field
	input.addEventListener('input', () => {
		const filter = input.value.toUpperCase(); 
		let hasResults = false;

		if (filter) {
			// Loop through each question
			questions.forEach(question => {
				const text = question.textContent.toUpperCase();
				const section = question.closest('.faq-section');

				// Show or hide question based on match
				if (text.includes(filter)) {
					question.style.display = '';
					if (section) section.style.display = '';
					hasResults = true;
				} else {
					question.style.display = 'none';
				}
			});

			// Hide section if it has no visible questions
			faqSections.forEach(section => {
				const visibleQuestions = section.querySelectorAll('.question:not([style*="display: none"])');
				section.style.display = visibleQuestions.length ? '' : 'none';
			});

			// Show or hide the "no results" message
			noResults.style.display = hasResults ? 'none' : '';
		} else {
			// If input is empty, show all questions and sections
			questions.forEach(q => q.style.display = '');
			faqSections.forEach(s => s.style.display = '');
			noResults.style.display = 'none';
		}
	});
});
